/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const cabinetMeetingRoutes = {
  name: RouteName.CabinetMeeting,
  path: "conseil-ministres",
  component: () =>
    import("@follaw-fr/views/side_menu_views/ConseilMinistres.vue"),
};
